function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import HubspotContactFormProps from "segments/desktop/core-components/hubspot-contact-form/default-props";
import { LOGO_COMPANY_FIELDS } from "segments/desktop/core-components/logos/logos-const";
import { MD, XS_M } from "constants/sizes";
export default _object_spread_props(_object_spread({}, HubspotContactFormProps), {
    backgroundLayers: 3,
    title: "Contact sales to see why monday is the new way of working",
    titleSize: MD,
    benefits: [
        {
            title: "Across <b>190+</b> countries",
            description: "Meet with a product consultant to see how monday.com can fit your exact business needs",
            icon: "/static/img/contact-sales/countries_icon.png"
        },
        {
            title: "<b>152k+</b> paying customers",
            description: "Explore our tailored pricing plans based on your goals and priorities",
            icon: "/static/img/contact-sales/customers_icon.png"
        },
        {
            title: "Serving <b>200+</b> industries",
            description: "Boost productivity from day one by building your team's ideal workflow",
            icon: "/static/img/contact-sales/industries_icon.png"
        }
    ],
    hideSupportStatement: false,
    hideLogos: false,
    logosTitle: {
        title: "<monday-bold>Trusted by top companies and brands</monday-bold>",
        titleSize: XS_M,
        textAlign: "left"
    },
    logos: {
        numberOfCompanies: 5,
        companyField: LOGO_COMPANY_FIELDS.ENTERPRISE
    },
    paddingBottom: "32px"
});
